/* 日志服务 */
import http from '@/utils/http'
import config from '@/config/config'
import store from '@/store/store'

const api = {
  traceUrl: `${config.traceUrl}/addH5/`,
  getIpUrl: `${config.traceUrl}/getIp/`,
}

/**
 * 发送日志
 * @param {string} eventName 事件名
 * @param {object} [logObject={}] 日志信息对象
 * @param {string | number} [userId=''] 用户id，登录状态则传值，否则传空字符串
 */
async function sendTraceLog(eventName, logObject = {}, userId = '') {
  let log = {}
  log.timestamp = Math.floor(new Date().getTime() / 1000)
  log.bparams = []
  log.bparams[0] = logObject
  let bparams = log.bparams[0]
  bparams.user_id = userId
  bparams.event = eventName
  bparams.refer = 'ilisten-h5'
  bparams.clientIp = await getTraceIp()
  bparams.browser = store.getters.browser
  bparams.system = store.getters.system
  log.bparams = JSON.stringify(log.bparams)
  try {
    await http.get(api.traceUrl, log)
  } catch (e) {
    // console.error('发送日志失败', e)
  }
}

async function getIp() {
  try {
    let ipInfo = await http.get(api.getIpUrl)
    return ipInfo
  } catch (e) {
    // console.error('发送日志失败', e)
  }
}

async function getTraceIp() {
  if (store.getters.clientIp) return store.getters.clientIp
  try {
    let ipInfo = await getIp()
    if (ipInfo) return ipInfo.ip
  } catch (e) {
    // console.error('获取ip失败', e)
  }
}

/**
 * 发送访问日志
 * @param {object} [{ path = '', fullPath = '', pageName = '', routeName = '' userId = '' }={}] 路由path，完整路径，页面名称，路由名称，用户id
 */
async function sendAccessLog({ path = '', fullPath = '', pageName = '', routeName = '', userId = '' } = {}) {
  let eventName = 'access'
  let logObject = {
    path,
    fullPath,
    pageName,
    routeName,
  }
  try {
    await sendTraceLog(eventName, logObject, userId)
  } catch (e) {
    // console.error('发送日志失败', e)
  }
}

export { sendTraceLog, sendAccessLog, getIp }